import { useState, useEffect } from "react";
import Logo from "@/components/Logo";

const dienstenLinks = [
  { label: "Ramen reparatie", href: "/ramen-reparatie/", icon: "raam" },
  { label: "Kozijnreparatie", href: "/kozijn-reparatie/", icon: "kozijn" },
  { label: "Schuifpui reparatie", href: "/schuifpui-reparatie/", icon: "schuifpui" },
  { label: "Draaikiepraam reparatie", href: "/draaikiepraam-reparatie/", icon: "draaikiep" },
  { label: "Glas vervangen", href: "/glas-vervangen/", icon: "glas" },
  { label: "Slot- en cilindervervanging", href: "/slot-cilinder-vervangen/", icon: "slot" },
  { label: "Velux & dakraam reparatie", href: "/velux-reparatie/", icon: "velux" },
  { label: "Inbraakschade reparatie", href: "/inbraakschade-reparatie/", icon: "inbraak", badge: "24/7" },
  { label: "Raamkruk vervangen", href: "/raamkruk-vervangen/", icon: "kruk" },
  { label: "Slotenmaker 24/7", href: "/slotenmaker-eindhoven/", icon: "slotenmaker", badge: "24/7" },
];

function ServiceIcon({ type }: { type: string }) {
  const cls = "w-4 h-4 flex-shrink-0";
  switch (type) {
    case "kozijn":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="3" y1="9" x2="21" y2="9" />
          <line x1="9" y1="21" x2="9" y2="9" />
        </svg>
      );
    case "schuifpui":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <path d="M15 3v18" />
        </svg>
      );
    case "draaikiep":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
        </svg>
      );
    case "glas":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="12" y1="3" x2="12" y2="21" />
          <line x1="3" y1="12" x2="21" y2="12" />
        </svg>
      );
    case "slot":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      );
    case "velux":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="5" />
          <line x1="12" y1="1" x2="12" y2="3" />
          <line x1="12" y1="21" x2="12" y2="23" />
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
          <line x1="1" y1="12" x2="3" y2="12" />
          <line x1="21" y1="12" x2="23" y2="12" />
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </svg>
      );
    case "inbraak":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      );
    case "kruk":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3" />
          <path d="M12 2v4" />
          <path d="M12 18v4" />
          <path d="M4.93 4.93l2.83 2.83" />
          <path d="M16.24 16.24l2.83 2.83" />
          <path d="M2 12h4" />
          <path d="M18 12h4" />
          <path d="M4.93 19.07l2.83-2.83" />
          <path d="M16.24 7.76l2.83-2.83" />
        </svg>
      );
    case "slotenmaker":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          <circle cx="12" cy="16" r="1" />
        </svg>
      );
    case "raam":
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="12" y1="3" x2="12" y2="21" />
        </svg>
      );
    default:
      return (
        <svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
        </svg>
      );
  }
}

export default function Header() {
  const { t } = useTranslation("home");
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileDienstenOpen, setMobileDienstenOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-[100] bg-white border-b border-brand-border transition-shadow duration-300 ${
        scrolled ? "shadow-sm" : ""
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 flex items-center justify-between h-16 md:h-20">
        <Logo variant="header" />

        <nav className="hidden md:flex items-center gap-8">
          <div
            className="relative"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <button
              className="font-geist text-sm text-brand-text hover:text-brand-blue transition-colors flex items-center gap-1 whitespace-nowrap"
              aria-label="Bekijk alle diensten"
              aria-expanded={dropdownOpen}
            >
              {t("header.nav.diensten")}
              <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-sm"></i>
            </button>
            {dropdownOpen && (
              <div className="absolute top-full left-0 pt-2">
                <div className="bg-brand-cream rounded-xl shadow-lg border border-brand-border p-2 min-w-[260px]">
                  {dienstenLinks.map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="flex items-center gap-2.5 px-3 py-2.5 text-sm text-brand-text hover:text-brand-blue hover:bg-white rounded-lg transition-colors"
                    >
                      <span className="text-brand-text/60">
                        <ServiceIcon type={link.icon} />
                      </span>
                      <span className="font-geist">{link.label}</span>
                      {link.badge && (
                        <span className="ml-auto font-geist-mono text-[10px] font-bold bg-red-600 text-white px-1.5 py-0.5 rounded">
                          {link.badge}
                        </span>
                      )}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
          <a
            href="/#wijken"
            className="font-geist text-sm text-brand-text hover:text-brand-blue transition-colors whitespace-nowrap"
          >
            {t("header.nav.wijken")}
          </a>
          <a
            href="/blog/"
            className="font-geist text-sm text-brand-text hover:text-brand-blue transition-colors whitespace-nowrap"
          >
            Blog
          </a>
          <a
            href="/#realisaties"
            className="font-geist text-sm text-brand-text hover:text-brand-blue transition-colors whitespace-nowrap"
          >
            {t("header.nav.realisaties")}
          </a>
          <a
            href="/wie-zijn-wij/"
            className="font-geist text-sm text-brand-text hover:text-brand-blue transition-colors whitespace-nowrap"
          >
            {t("header.nav.overOns")}
          </a>
          <a
            href="/contact/"
            className="font-geist text-sm text-brand-text hover:text-brand-blue transition-colors whitespace-nowrap"
          >
            {t("header.nav.contact")}
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="/contact/"
            className="hidden md:inline-flex font-geist font-bold text-sm bg-brand-yellow text-brand-text px-5 py-2.5 rounded-full hover:bg-brand-yellow/90 transition-colors whitespace-nowrap"
            aria-label="Vraag gratis offerte aan"
          >
            {t("header.cta")}
          </a>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-11 h-11 flex items-center justify-center text-brand-text cursor-pointer"
            aria-label={mobileOpen ? "Sluit menu" : "Open menu"}
            aria-expanded={mobileOpen}
          >
            {mobileOpen ? (
              <i className="ri-close-line text-2xl w-6 h-6 flex items-center justify-center"></i>
            ) : (
              <i className="ri-menu-line text-2xl w-6 h-6 flex items-center justify-center"></i>
            )}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-brand-border px-4 pb-6 max-h-[80vh] overflow-y-auto">
          <div className="flex flex-col gap-0 pt-2">
            <button
              onClick={() => setMobileDienstenOpen(!mobileDienstenOpen)}
              className="flex items-center justify-between font-geist text-base text-brand-text py-4 cursor-pointer min-h-11"
              aria-expanded={mobileDienstenOpen}
            >
              <span>Onze diensten</span>
              {mobileDienstenOpen ? (
                <i className="ri-arrow-up-s-line w-5 h-5 flex items-center justify-center"></i>
              ) : (
                <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center"></i>
              )}
            </button>
            {mobileDienstenOpen && (
              <div className="pl-2 flex flex-col gap-0.5 pb-2 border-l-2 border-brand-yellow ml-1">
                {dienstenLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="flex items-center gap-2 font-geist text-base text-brand-text/70 py-3 hover:text-brand-blue min-h-11"
                  >
                    <span className="text-brand-text/40 w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <ServiceIcon type={link.icon} />
                    </span>
                    <span>{link.label}</span>
                    {link.badge && (
                      <span className="ml-auto font-geist-mono text-[10px] font-bold bg-red-600 text-white px-1.5 py-0.5 rounded">
                        {link.badge}
                      </span>
                    )}
                  </a>
                ))}
              </div>
            )}
            <a href="/#wijken" className="font-geist text-base text-brand-text py-4 border-t border-brand-border/40 min-h-11">
              {t("header.nav.wijken")}
            </a>
            <a href="/blog/" className="font-geist text-base text-brand-text py-4 border-t border-brand-border/40 min-h-11">
              Blog
            </a>
            <a href="/#realisaties" className="font-geist text-base text-brand-text py-4 border-t border-brand-border/40 min-h-11">
              {t("header.nav.realisaties")}
            </a>
            <a href="/wie-zijn-wij/" className="font-geist text-base text-brand-text py-4 border-t border-brand-border/40 min-h-11">
              {t("header.nav.overOns")}
            </a>
            <a href="/contact/" className="font-geist text-base text-brand-text py-4 border-t border-brand-border/40 min-h-11">
              {t("header.nav.contact")}
            </a>
            <div className="flex flex-col gap-3 mt-3 pt-3 border-t border-brand-border/40">
              <a
                href="/contact/"
                className="font-geist font-bold text-base bg-brand-yellow text-brand-text px-5 py-4 rounded-full text-center whitespace-nowrap min-h-11"
                aria-label="Vraag gratis offerte aan"
              >
                {t("header.cta")}
              </a>
              <a
                href="tel:+31407987470"
                className="font-geist font-bold text-base bg-brand-blue text-white px-5 py-4 rounded-full text-center whitespace-nowrap min-h-11"
              >
                040 798 7470
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}